import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFiltersBrand = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.brand || null);
